<div class="location-container">
  <div class="location-buttons-container">
    <mat-chip-list>
      <ng-container *ngFor="let btn of Object.keys(locationButtons)">
        <mat-chip
          (click)="handleLocationButtonClick($event, btn)"
          class="location-button"
          [ngClass]="{
            active: locationButtons[btn].active,
            disabled: btn === 'current' && (isFetchingCurrentLocation || isLocationBlocked)
          }"
          [disabled]="isFetchingCurrentLocation || isLocationBlocked"
          *ngIf="!(btn === 'map' && showMapContainer)"
        >
          <mat-icon class="material-symbols-outlined">{{ icons['location'][btn] }}</mat-icon>
          <span *ngIf="btn !== 'current'" class="location-button-text">{{
            locationButtons[btn].text | translate
          }}</span>
          <span *ngIf="btn === 'current'" class="location-button-text">
            {{
              (isFetchingCurrentLocation
                ? 'form.location.fetching_current_location'
                : 'form.location.use_current_location'
              ) | translate
            }}
          </span>
        </mat-chip>
      </ng-container>
    </mat-chip-list>
  </div>

  <div class="map-container" *ngIf="showMapContainer" [@fadeIn]>
    <div #mapContainer class="map"></div>
  </div>

  <p class="form-hint" *ngIf="showMapContainer">
    <mat-icon>info</mat-icon>{{ 'form.location.drag_pin' | translate }}
  </p>

  <div class="location-fields" *ngIf="getLocationValue()" [@fadeIn]>
    <div class="coordinate-fields">
      <mat-form-field appearance="fill" class="coordinate-field">
        <mat-label>{{ 'form.location.latitude' | translate }}</mat-label>
        <input matInput [value]="getCurrentLocationFromForm().lat" readonly />
      </mat-form-field>

      <mat-form-field appearance="fill" class="coordinate-field">
        <mat-label>{{ 'form.location.longitude' | translate }}</mat-label>
        <input matInput [value]="getCurrentLocationFromForm().lng" readonly />
      </mat-form-field>
    </div>
  </div>
</div>
